import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AUTH_STATUS, useAuthState } from '../auth/AuthStateContext';
import { hasStoredAuthToken } from '../shared/utils/authPersistence';
import { hasGuestSpectatorAdmission } from '../shared/utils/guestSpectatorSession';

function requestedTableCode(location) {
  try {
    const pathname = String(location?.pathname || '');
    const match = pathname.match(/^\/table\/([^/?#]+)/i);
    if (match?.[1]) return decodeURIComponent(match[1]).trim();
    const params = new URLSearchParams(String(location?.search || ''));
    return String(params.get('tableCode') || params.get('table_code') || params.get('table_id') || '').trim();
  } catch (_) {
    return '';
  }
}

/**
 * Auth-only routes, with one narrow exception for a server-issued Guest
 * spectator admission bound to the requested existing table.
 *
 * The client-side admission check is UX routing only. Game-server authorization
 * is enforced separately by the signed guest spectator token.
 */
export default function ProtectedRoute({ children, allowGuestSpectator = false }) {
  const { status } = useAuthState();
  const location = useLocation();
  const hasToken = hasStoredAuthToken();

  if (status === AUTH_STATUS.GUEST || !hasToken) {
    const tableCode = allowGuestSpectator ? requestedTableCode(location) : '';
    if (allowGuestSpectator && tableCode && hasGuestSpectatorAdmission(tableCode)) {
      return children;
    }
    return <Navigate to="/?guestLogin=1&reason=auth_required" replace />;
  }

  return children;
}
